module.exports = __webpack_public_path__ + "static/img/bgc.a591aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgc.png
// module id = 8y4z
// module chunks = 1